function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.9375 4.375H4.25C3.64062 4.375 3.125 4.89062 3.125 5.5V11.5C3.125 12.1328 3.64062 12.625 4.25 12.625H5.9375C6.24219 12.625 6.5 12.8828 6.5 13.1875C6.5 13.4922 6.24219 13.75 5.9375 13.75H4.25C3.00781 13.75 2 12.7422 2 11.5V5.5C2 4.25781 3.00781 3.25 4.25 3.25H5.9375C6.24219 3.25 6.5 3.50781 6.5 3.8125C6.5 4.11719 6.24219 4.375 5.9375 4.375ZM13.8359 8.89844L10.6484 12.0859C10.4375 12.2969 10.0859 12.2969 9.85156 12.0859C9.64062 11.875 9.64062 11.5 9.85156 11.2891L12.0781 9.0625H6.3125C6.00781 9.0625 5.75 8.80469 5.75 8.5C5.75 8.19531 6.00781 7.9375 6.3125 7.9375H12.0781L9.85156 5.71094C9.64062 5.5 9.64062 5.125 9.85156 4.91406C10.0625 4.70312 10.4375 4.70312 10.6484 4.91406L13.8359 8.10156C14.0469 8.3125 14.0469 8.6875 13.8359 8.89844Z",
  fill: "#E03A3E"
});

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.47b34891.svg";
export { ForwardRef as ReactComponent };